"use client";

import { ActivityDisplayPreview } from "./previews";

type ScubaDivingDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function ScubaDivingDisplay({
  data,
  participants,
}: ScubaDivingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="scuba-diving"
      data={data}
      participants={participants}
    />
  );
}
